module.exports = __webpack_public_path__ + "img/storeaudit.90b65cfa.png";